import { render, staticRenderFns } from "./SingleAddressEdit.vue?vue&type=template&id=e56494a8&"
import script from "./SingleAddressEdit.vue?vue&type=script&lang=js&"
export * from "./SingleAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports